export default __webpack_public_path__ + "static/media/estation.24338b44.svg";